// Helpers for typing / pasting lists of e-mail addresses (EmailTagsInput)

const EMAIL_REGEX =
  /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*\.[a-z]{2,}$/i

// Characters that end an address while typing
export const EMAIL_SEPARATOR_REGEX = /[\s,;]/

export const normalizeEmail = (raw: string): string =>
  raw
    .trim()
    .replace(/^mailto:/i, '')
    .replace(/^[<("'[]+|[>)"'\]]+$/g, '')
    .trim()
    .toLowerCase()

export const isValidEmail = (email: string): boolean => email.length <= 255 && EMAIL_REGEX.test(email)

/**
 * Split typed or pasted text into normalized addresses.
 * Handles separators (comma, semicolon, whitespace, new lines) and
 * "Jan Kowalski <jan@x.pl>" entries copied from mail clients.
 */
export const splitEmails = (text: string): string[] =>
  text
    .replace(/[^,;\n<>]*<([^<>]+)>/g, ' $1 ')
    .split(/[\s,;]+/)
    .map(normalizeEmail)
    .filter(email => email !== '')
